<button mat-menu-item [routerLink]="navigationUrl" routerLinkActive="active">
  <mat-icon>{{ icon }}</mat-icon>
  @if (!menuMinimized) {
  <span>{{ itemLabel | translate }}</span>
  }
</button>
<mat-divider />
